const dashboard_en = {
  title: 'Dashboard',
  searchPlaceholder: 'Search dashboard...',

  // Section 1 — My Trade Shows
  myTradeShows: 'My Trade Shows',
  ongoing: 'Ongoing',
  upcoming: 'Upcoming',
  past: 'Past',
  events: 'events',

  // Section 2 — Next Event
  nextEvent: 'Next Event',
  location: 'Location',
  dateRange: 'Date',
  countdown: 'Days until setup',
  daysRemaining: '{count} days',
  boothNumber: 'Booth Number',
  boothNotAssigned: 'Not yet assigned',
  exhibitsAssigned: 'Exhibits assigned',
  planningComplete: 'Planning complete',
  dataMissing: 'Data missing',
  viewDetails: 'View details',
  noUpcomingEvent: 'No upcoming events',
  noUpcomingEventHint: 'Plan your next trade show to get started.',
  createNewPlan: 'Create new plan',

  // Section 3 — Open Tasks
  openTasks: 'Open Tasks',
  noOpenTasks: "No open tasks — you're all set.",
  taskIncompletePlan: 'Incomplete trade show plan',
  taskUnassignedExhibits: 'Exhibits not assigned',
  taskPendingInvitation: 'Pending team invitation',
  due: 'Due',

  // Section 4 — Master Data
  masterDataStatus: 'Master Data',
  activeProjects: 'Active Projects',
  exhibits: 'Exhibits',
  categories: 'Categories',
  teamMembers: 'Team Members',

  // Section 5 — Quick Actions
  quickActions: 'Quick Actions',
  createNewExhibit: 'Create new exhibit',
  inviteTeamMember: 'Invite team member',

  // Legacy (kept for backwards compatibility with any other consumer)
  future: 'Future',
  currentlyTakingPlace: 'Currently Taking Place',
  fairs: 'Fairs',
  exhibitionOverview: 'Exhibition Overview',
  organisationOverview: 'Organisation Overview',
}

export default dashboard_en
